// "Go back" on the static pages (FAQ, privacy, terms, legal notice). The CSP
// (`script-src 'self'`) blocks inline handlers, so the link is wired here: it
// steps back when the visitor came from this site, else follows its href.
// Whether "Go back" on a static page can step back in the history: only when
// the visitor came from a page of this site. Otherwise (a direct visit, a link
// from another site or an email) the link follows its href, the homepage.
function $eabb4d93d6ab6c24$export$a0cdb363b249b691(referrer, origin) {
    if (referrer === "") return false;
    try {
        return new URL(referrer).origin === origin;
    } catch  {
        return false;
    }
}


for (const link of document.querySelectorAll("a[data-go-back]"))link.addEventListener("click", (event)=>{
    if (!(0, $eabb4d93d6ab6c24$export$a0cdb363b249b691)(document.referrer, window.location.origin)) return;
    event.preventDefault();
    history.back();
});


//# sourceMappingURL=faq.1602f12b.js.map
